import pageNotFound from "../../assets/icons/404.svg";
import underConstruction from "../../assets/icons/under-construction.svg";
import "./errorPage.css";
import { useLocation } from "react-router-dom";

export default function Error() {
  const location = useLocation();
  return (
    <div className="page-not-found">
      <div
        className={`page-not-found-left ${
          location.pathname === "/page-under-construction" &&
          "page-under-construction-left"
        }`}
      >
        <h1>
          {location.pathname === "/page-not-found" ? (
            <>
              <span>Sorry!,</span> this page isn’t available
            </>
          ) : (
            <>
              <span>Oops!,</span> Under maintenance
            </>
          )}
        </h1>
        {location.pathname === "/page-not-found" ? (
          <p>The page you were looking for couldn’t be found</p>
        ) : (
          <p>
            Our website is currently undergoing scheduled maintenance. We Should
            be back shortly. Thank you for your patience.
          </p>
        )}
        <a href="/reseller-agent-dashboard">
          Go back to the <span>Home page</span>
        </a>
      </div>
      <div className="page-not-found-right">
        <img
          src={
            location.pathname === "/page-not-found"
              ? pageNotFound
              : underConstruction
          }
          alt=" "
        />
      </div>
    </div>
  );
}
